import { render, staticRenderFns } from "./receive-material.vue?vue&type=template&id=4b70e2a0&scoped=true&"
import script from "./receive-material.vue?vue&type=script&lang=js&"
export * from "./receive-material.vue?vue&type=script&lang=js&"
import style0 from "./receive-material.vue?vue&type=style&index=0&id=4b70e2a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b70e2a0",
  null
  
)

export default component.exports